import { render, staticRenderFns } from "./onePage.vue?vue&type=template&id=d606a0a8&"
import script from "./onePage.vue?vue&type=script&lang=js&"
export * from "./onePage.vue?vue&type=script&lang=js&"
import style0 from "./onePage.vue?vue&type=style&index=0&id=d606a0a8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports